module.exports = __webpack_public_path__ + "img/4-01-06-change.7c82e278.svg";